import { Component, Input, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cache-notification',
  templateUrl: './cache-notification.component.html',
  styleUrls: ['./cache-notification.component.scss'],
})
export class CacheNotificationComponent  implements OnInit {

  @Input() color: string = ''
  visible: boolean = false
  
  constructor(private cookieService: CookieService) { 
    this.visible = false

    // const cacheNotificationClosed: boolean = cookieService.get('cache-notification-closed') == 'true'
    // if (cacheNotificationClosed) {
    //   this.visible = false
    // }

    // if (!cacheNotificationClosed) {
    //   if (navigator?.storage?.estimate) {
    //     // Now check the numbers
    //     try {
    //       navigator.storage.estimate().then((value: StorageEstimate) => {
    //         if (value.usage > value.quota * .7) {
    //           this.visible = true
    //         }
    //       })             
    //     } catch (exc) {
    //       // Do nothing
    //     }
    //   }
    // }
  }

  ngOnInit() {

  }

  get hasColor(): boolean {
    return this.color != null && this.color.length > 0
  }

  get colorHex(): string {
    if (this.hasColor) {
      return '#' + this.color
    }
    return ''
  }

  closeClicked() {
    this.visible = false
    this.cookieService.set('cache-notification-closed', 'true', Number.MAX_SAFE_INTEGER)
  }

}
